// extracted by mini-css-extract-plugin
module.exports = {"Path1":"CategoryIcon_Path1__KTeoh","CLS1":"CategoryIcon_CLS1__3gWDp","CLS2":"CategoryIcon_CLS2__2vjPl"};